/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ player: NonNullable<unknown>, team: NonNullable<unknown> }} Push_Roster_Removed_TitleInputs */

const th_push_roster_removed_title = /** @type {(inputs: Push_Roster_Removed_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} ออกจาก ${i?.team}`)
};

const en_push_roster_removed_title = /** @type {(inputs: Push_Roster_Removed_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} left ${i?.team}`)
};

const ja_push_roster_removed_title = /** @type {(inputs: Push_Roster_Removed_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} が ${i?.team} を離脱`)
};

const zh_push_roster_removed_title = /** @type {(inputs: Push_Roster_Removed_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} 离开了 ${i?.team}`)
};

const es_push_roster_removed_title = /** @type {(inputs: Push_Roster_Removed_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} ha dejado ${i?.team}`)
};

const pt_push_roster_removed_title = /** @type {(inputs: Push_Roster_Removed_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} saiu do ${i?.team}`)
};

const id_push_roster_removed_title = /** @type {(inputs: Push_Roster_Removed_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} meninggalkan ${i?.team}`)
};

const fr_push_roster_removed_title = /** @type {(inputs: Push_Roster_Removed_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} a quitté ${i?.team}`)
};

const tl_push_roster_removed_title = /** @type {(inputs: Push_Roster_Removed_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Umalis si ${i?.player} sa ${i?.team}`)
};

const vi_push_roster_removed_title = /** @type {(inputs: Push_Roster_Removed_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} rời ${i?.team}`)
};

const ko_push_roster_removed_title = /** @type {(inputs: Push_Roster_Removed_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player}이(가) ${i?.team}을(를) 떠났습니다`)
};

const de_push_roster_removed_title = /** @type {(inputs: Push_Roster_Removed_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} hat ${i?.team} verlassen`)
};

const ru_push_roster_removed_title = /** @type {(inputs: Push_Roster_Removed_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} покинул ${i?.team}`)
};

const tr_push_roster_removed_title = /** @type {(inputs: Push_Roster_Removed_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player}, ${i?.team} takımından ayrıldı`)
};

const it_push_roster_removed_title = /** @type {(inputs: Push_Roster_Removed_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} ha lasciato ${i?.team}`)
};

const pl_push_roster_removed_title = /** @type {(inputs: Push_Roster_Removed_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} odszedł z ${i?.team}`)
};

const uk_push_roster_removed_title = /** @type {(inputs: Push_Roster_Removed_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} залишив ${i?.team}`)
};

const hi_push_roster_removed_title = /** @type {(inputs: Push_Roster_Removed_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} ने ${i?.team} छोड़ दी`)
};

const ar_push_roster_removed_title = /** @type {(inputs: Push_Roster_Removed_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`غادر ${i?.player} فريق ${i?.team}`)
};

const ms_push_roster_removed_title = /** @type {(inputs: Push_Roster_Removed_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} meninggalkan ${i?.team}`)
};

const bn_push_roster_removed_title = /** @type {(inputs: Push_Roster_Removed_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} ${i?.team} ছেড়েছেন`)
};

const zh_tw2_push_roster_removed_title = /** @type {(inputs: Push_Roster_Removed_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} 離開了 ${i?.team}`)
};

const zh_hk2_push_roster_removed_title = /** @type {(inputs: Push_Roster_Removed_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} 離開了 ${i?.team}`)
};

const ur_push_roster_removed_title = /** @type {(inputs: Push_Roster_Removed_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} نے ${i?.team} چھوڑ دی`)
};

const fa_push_roster_removed_title = /** @type {(inputs: Push_Roster_Removed_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} از ${i?.team} جدا شد`)
};

const sw_push_roster_removed_title = /** @type {(inputs: Push_Roster_Removed_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} ameondoka ${i?.team}`)
};

const nl_push_roster_removed_title = /** @type {(inputs: Push_Roster_Removed_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.player} heeft ${i?.team} verlaten`)
};

/**
* | output |
* | --- |
* | "{player} left {team}" |
*
* @param {Push_Roster_Removed_TitleInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_roster_removed_title = /** @type {((inputs: Push_Roster_Removed_TitleInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Roster_Removed_TitleInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_push_roster_removed_title(inputs)
	if (locale === "ja") return ja_push_roster_removed_title(inputs)
	if (locale === "zh") return zh_push_roster_removed_title(inputs)
	if (locale === "es") return es_push_roster_removed_title(inputs)
	if (locale === "pt") return pt_push_roster_removed_title(inputs)
	if (locale === "id") return id_push_roster_removed_title(inputs)
	if (locale === "fr") return fr_push_roster_removed_title(inputs)
	if (locale === "tl") return tl_push_roster_removed_title(inputs)
	if (locale === "vi") return vi_push_roster_removed_title(inputs)
	if (locale === "ko") return ko_push_roster_removed_title(inputs)
	if (locale === "de") return de_push_roster_removed_title(inputs)
	if (locale === "ru") return ru_push_roster_removed_title(inputs)
	if (locale === "tr") return tr_push_roster_removed_title(inputs)
	if (locale === "it") return it_push_roster_removed_title(inputs)
	if (locale === "pl") return pl_push_roster_removed_title(inputs)
	if (locale === "uk") return uk_push_roster_removed_title(inputs)
	if (locale === "hi") return hi_push_roster_removed_title(inputs)
	if (locale === "ar") return ar_push_roster_removed_title(inputs)
	if (locale === "ms") return ms_push_roster_removed_title(inputs)
	if (locale === "bn") return bn_push_roster_removed_title(inputs)
	if (locale === "zh-TW") return zh_tw2_push_roster_removed_title(inputs)
	if (locale === "zh-HK") return zh_hk2_push_roster_removed_title(inputs)
	if (locale === "ur") return ur_push_roster_removed_title(inputs)
	if (locale === "fa") return fa_push_roster_removed_title(inputs)
	if (locale === "sw") return sw_push_roster_removed_title(inputs)
	if (locale === "nl") return nl_push_roster_removed_title(inputs)
	return en_push_roster_removed_title(inputs)
});